import { render, staticRenderFns } from "./VariationModal.vue?vue&type=template&id=2063eeb6&scoped=true"
import script from "./VariationModal.vue?vue&type=script&lang=js"
export * from "./VariationModal.vue?vue&type=script&lang=js"
import style0 from "./VariationModal.vue?vue&type=style&index=0&id=2063eeb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2063eeb6",
  null
  
)

export default component.exports